
import { useState } from "react";
import { Mail, Phone, MapPin, Send, Loader2 } from "lucide-react";
import { apiBaseUrl } from "../utils/common";
import { useSelector } from "react-redux";
import {
  ShieldAlert,
  Trophy,
  Globe,
  Facebook,
  Instagram,
  Twitter,
  Youtube,
  Linkedin,
  MessageCircle,
} from "lucide-react";

import {
  FaDiscord,
  FaPinterestP,
  FaRedditAlien,
  FaSnapchatGhost,
} from "react-icons/fa";

import { SiTiktok } from "react-icons/si";
export default function ContactUsPage() {
  const webSiteData = useSelector((state) => state.website) || {};

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [responseMsg, setResponseMsg] = useState("");
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const validateForm = (data) => {
    const errors = {};

    if (!data.name.trim()) {
      errors.name = "Name is required";
    }

    // if (!data.phone.trim()) {
    //   errors.phone = "Phone is required";
    // } else if (!/^[6-9]\d{9}$/.test(data.phone)) {
    //   errors.phone = "Enter valid 10-digit Indian number";
    // }

    if (!data.email.trim()) {
      errors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
      errors.email = "Invalid email";
    }

    if (!data.message.trim()) {
      errors.message = "Message is required";
    } else if (data.message.length < 10) {
      errors.message = "Minimum 10 characters required";
    }

    if (!data.subject.trim()) {
      errors.subject = "Subject is required";
    } else if (data.subject.length < 10) {
      errors.subject = "Subject 10 characters required";
    }

    return errors;
  };

  // Dummy API Call
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});

    const validationErrors = validateForm(formData);

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setLoading(false); // ✅ FIX
      return;
    }

    setResponseMsg("");

    try {

      const response = await fetch(`${apiBaseUrl}/api/news-letter/contact-us`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json", // ✅ better
        },
        body: JSON.stringify({
          type: "contact",
          ...formData,
        }),
      });

      const data = await response.json();

      console.log(data);

      setResponseMsg("Message sent successfully ✅");

      setFormData({
        name: "",
        email: "",
        subject: "",
        message: "",
      });
    } catch (error) {
      setResponseMsg("Something went wrong ❌");
    }

    setLoading(false);
  };

  return (
    <main className="min-h-screen bg-white dark:bg-gray-950 text-gray-900 dark:text-white py-12 transition-colors">
      <div className="container mx-auto px-4">

        {/* Header */}
        <div className="text-center mb-10">
          <h1 className="text-4xl font-bold">
            Contact Us
          </h1>

          <p className="mt-3 text-gray-600 dark:text-gray-400 max-w-xl mx-auto">
            Have questions, feedback, or need support? Send us a message and
            we'll get back to you.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8 max-w-6xl mx-auto">

          {/* Left Contact Info */}
          <div className="space-y-5">

            {/* EMAIL */}
            {(webSiteData?.emailId ||
              webSiteData?.supportEmail) && (
                <div className="rounded-2xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-5 shadow-sm">

                  <div className="flex items-start gap-3">

                    <Mail className="w-5 h-5 text-blue-500 mt-1" />

                    <div>

                      <p className="font-semibold">
                        Email
                      </p>

                      {webSiteData?.emailId && (
                        <a
                          href={`mailto:${webSiteData?.emailId}`}
                          className="text-sm text-gray-500 hover:text-blue-500 block break-all"
                        >
                          {webSiteData?.emailId}
                        </a>
                      )}

                      {webSiteData?.supportEmail && (
                        <a
                          href={`mailto:${webSiteData?.supportEmail}`}
                          className="text-sm text-gray-500 hover:text-blue-500 block break-all"
                        >
                          {
                            webSiteData?.supportEmail
                          }
                        </a>
                      )}

                    </div>

                  </div>

                </div>
              )}

            {/* PHONE */}
            {(webSiteData?.phoneNumber ||
              webSiteData?.whatsappNumber) && (
                <div className="rounded-2xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-5 shadow-sm">

                  <div className="flex items-start gap-3">

                    <Phone className="w-5 h-5 text-green-500 mt-1" />

                    <div>

                      <p className="font-semibold">
                        Phone
                      </p>

                      {webSiteData?.phoneNumber && (
                        <a
                          href={`tel:${webSiteData?.phoneNumber}`}
                          className="text-sm text-gray-500 hover:text-green-500 block"
                        >
                          {
                            webSiteData?.phoneNumber
                          }
                        </a>
                      )}

                      {webSiteData?.whatsappNumber && (
                        <a
                          href={`https://wa.me/${webSiteData?.whatsappNumber}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-sm text-gray-500 hover:text-green-500 block"
                        >
                          WhatsApp:{" "}
                          {
                            webSiteData?.whatsappNumber
                          }
                        </a>
                      )}

                    </div>

                  </div>

                </div>
              )}

            {/* ADDRESS */}
            {webSiteData?.address && (
              <div className="rounded-2xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-5 shadow-sm">

                <div className="flex items-start gap-3">

                  <MapPin className="w-5 h-5 text-red-500 mt-1" />

                  <div>

                    <p className="font-semibold">
                      Address
                    </p>

                    <p className="text-sm text-gray-500 leading-6">
                      {webSiteData?.address}
                    </p>

                  </div>

                </div>

              </div>
            )}

            {/* SOCIAL MEDIA */}
            <div className="rounded-2xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-5 shadow-sm">

              <p className="font-semibold mb-4">
                Follow Us
              </p>

              <div className="flex flex-wrap gap-3">

                {[
                  {
                    link:
                      webSiteData?.facebookLink,
                    icon: (
                      <Facebook size={18} />
                    ),
                    bg: "bg-blue-600",
                  },

                  {
                    link:
                      webSiteData?.instagramLink,
                    icon: (
                      <Instagram size={18} />
                    ),
                    bg: "bg-pink-500",
                  },

                  {
                    link:
                      webSiteData?.telegramLink,
                    icon: <Send size={18} />,
                    bg: "bg-sky-500",
                  },

                  {
                    link:
                      webSiteData?.twitterLink,
                    icon: (
                      <Twitter size={18} />
                    ),
                    bg: "bg-cyan-500",
                  },

                  {
                    link:
                      webSiteData?.youtubeLink,
                    icon: (
                      <Youtube size={18} />
                    ),
                    bg: "bg-red-600",
                  },

                  {
                    link:
                      webSiteData?.linkedinLink,
                    icon: (
                      <Linkedin size={18} />
                    ),
                    bg: "bg-blue-700",
                  },

                  {
                    link:
                      webSiteData?.discordLink,
                    icon: (
                      <FaDiscord size={18} />
                    ),
                    bg: "bg-indigo-600",
                  },

                  {
                    link:
                      webSiteData?.snapchatLink,
                    icon: (
                      <FaSnapchatGhost
                        size={18}
                      />
                    ),
                    bg: "bg-yellow-500 text-black",
                  },

                  {
                    link:
                      webSiteData?.pinterestLink,
                    icon: (
                      <FaPinterestP
                        size={18}
                      />
                    ),
                    bg: "bg-rose-600",
                  },

                  {
                    link:
                      webSiteData?.redditLink,
                    icon: (
                      <FaRedditAlien
                        size={18}
                      />
                    ),
                    bg: "bg-orange-500",
                  },
                ]
                  ?.filter((item) => item?.link)
                  ?.map((item, index) => (
                    <a
                      key={index}
                      href={item?.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={`w-11 h-11 rounded-full ${item?.bg} flex items-center justify-center text-white hover:scale-110 transition-all duration-300 shadow-md`}
                    >
                      {item?.icon}
                    </a>
                  ))}

              </div>

            </div>

            {/* MOBILE APPS */}
            {(webSiteData?.androidAppLink ||
              webSiteData?.iosAppLink) && (
                <div className="rounded-2xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-5 shadow-sm">

                  <p className="font-semibold mb-4">
                    Mobile Apps
                  </p>

                  <div className="flex flex-wrap gap-3">

                    {webSiteData?.androidAppLink && (
                      <a
                        href={
                          webSiteData?.androidAppLink
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src="https://footplayhd.com/play-store.png"
                          alt="play-store"
                          className="h-10"
                        />                      </a>
                    )}

                    {webSiteData?.iosAppLink && (
                      <a
                        href={
                          webSiteData?.iosAppLink
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src="https://footplayhd.com/app-store.png"
                          alt="app-store"
                          className="h-10"
                        />
                      </a>
                    )}

                  </div>

                </div>
              )}

          </div>
          {/* Contact Form */}
          <div className="lg:col-span-2">
            <div className="rounded-2xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 shadow-lg p-6">

              <form
                onSubmit={handleSubmit}
                className="space-y-5"
              >
                <div className="grid sm:grid-cols-2 gap-4">

                  <div>
                    <label className="block mb-2 text-sm font-medium">
                      Name
                    </label>

                    <input
                      type="text"
                      name="name"
                      // required
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="John Doe"
                      className="w-full rounded-xl border border-gray-300 dark:border-gray-700 bg-transparent px-4 py-3 outline-none focus:ring-2 focus:ring-blue-500"
                    />
                    {errors.name && <p className="text-red-500 text-sm">{errors.name}</p>}

                  </div>

                  <div>
                    <label className="block mb-2 text-sm font-medium">
                      Email
                    </label>

                    <input
                      type="email"
                      name="email"
                      // required
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="john@example.com"
                      className="w-full rounded-xl border border-gray-300 dark:border-gray-700 bg-transparent px-4 py-3 outline-none focus:ring-2 focus:ring-blue-500"
                    />
                    {errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}

                  </div>
                </div>

                <div>
                  <label className="block mb-2 text-sm font-medium">
                    Subject
                  </label>

                  <input
                    type="text"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    placeholder="Write subject"
                    className="w-full rounded-xl border border-gray-300 dark:border-gray-700 bg-transparent px-4 py-3 outline-none focus:ring-2 focus:ring-blue-500"
                  />
                  {errors.subject && <p className="text-red-500 text-sm">{errors.subject}</p>}

                </div>

                <div>
                  <label className="block mb-2 text-sm font-medium">
                    Message
                  </label>

                  <textarea
                    rows={6}
                    // required
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Write your message..."
                    className="w-full rounded-xl border border-gray-300 dark:border-gray-700 bg-transparent px-4 py-3 outline-none focus:ring-2 focus:ring-blue-500 resize-none"
                  />
                  {errors.message && <p className="text-red-500 text-sm">{errors.message}</p>}

                </div>

                {responseMsg && (
                  <div className="rounded-lg bg-gray-100 dark:bg-gray-800 px-4 py-3 text-sm">
                    {responseMsg}
                  </div>
                )}

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full rounded-xl bg-blue-600 hover:bg-blue-700 transition py-3 text-white font-medium flex justify-center items-center gap-2 disabled:opacity-70"
                >
                  {loading ? (
                    <>
                      <Loader2 className="w-4 h-4 animate-spin" />
                      Sending...
                    </>
                  ) : (
                    <>
                      <Send className="w-4 h-4" />
                      Send Message
                    </>
                  )}
                </button>

              </form>

            </div>
          </div>

        </div>
      </div>
    </main>
  );
}